import moment from 'moment';

export function utcForValueWithTZ(value: Date | string | null | undefined, tz: string): Date | null {
  return value && tz ? new Date(moment.utc(moment.tz(value, tz).format('YYYY-MM-DD HH:mm')).valueOf()) : null;
}

export function localForDateTimeWithTZ(date: Date, time: Date, tz: string): Date | null {
  if (date && time && tz) {
    const format = `${moment(date).utc().format('YYYY-MM-DD')} ${moment(time).utc().format('HH:mm')}`;
    return new Date(moment.utc(moment.tz(format, tz)).valueOf());
  }
  return null;
}
